import React from 'react';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';
export function TermsOfServicePage() {
  return <main data-id="element-493">
      <SEO title="Terms of Service" description="Terms of Service for Ambient Solutions LLC." data-id="element-494" />
      <PageHero title="Terms of Service" subtitle="The terms and conditions for using our website and services" data-id="element-495" />

      <section className="py-20 px-4 bg-white" data-id="element-496">
        <div className="max-w-3xl mx-auto prose prose-neutral" data-id="element-497">
          <p className="text-neutral-medium mb-8" data-id="element-498">Last Updated: May 2026</p>

          <div className="space-y-12" data-id="element-499">
            <div data-id="element-500">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-501">
                1. Acceptance of Terms
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-502">
                By accessing or using the Ambient Solutions LLC website and
                services, you agree to be bound by these Terms of Service and
                all applicable laws and regulations. If you do not agree with
                any of these terms, you are prohibited from using or accessing
                this site.
              </p>
            </div>

            <div data-id="element-503">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-504">
                2. Use of Services
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-505">
                Our services include helping families hire, train, and certify
                loved ones as professional caregivers. Use of these services is
                subject to specific service agreements, background check
                approvals, and compliance with state and federal healthcare
                regulations.
              </p>
            </div>

            <div data-id="element-506">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-507">
                3. Caregiver Certification
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-508">
                While we facilitate the training and certification process,
                approval is subject to mandatory background checks, successful
                completion of training modules, and regulatory compliance. We
                reserve the right to deny certification based on these criteria.
              </p>
            </div>

            <div data-id="element-509">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-510">
                4. Disclaimer
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-511">
                The materials on our website are provided on an 'as is' basis.
                Ambient Solutions LLC makes no warranties, expressed or implied,
                and hereby disclaims and negates all other warranties including,
                without limitation, implied warranties or conditions of
                merchantability, fitness for a particular purpose, or
                non-infringement of intellectual property or other violation of
                rights.
              </p>
            </div>

            <div data-id="element-512">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-513">
                5. Governing Law
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-514">
                These terms and conditions are governed by and construed in
                accordance with the laws of the State of Maryland and you
                irrevocably submit to the exclusive jurisdiction of the courts
                in that State.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}